import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/students/$studentId/feedback')({
  component: FeedbackLayout,
});

function FeedbackLayout() {
  return <Outlet />;
}
